/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GeoPoint } from './GeoPoint';
import {
  GeoPointFromJSON,
  GeoPointFromJSONTyped,
  GeoPointToJSON,
  GeoPointToJSONTyped,
} from './GeoPoint';
import { Location, LocationFromJSON, LocationToJSON } from './Location';
import { Town, TownFromJSON, TownToJSON } from './Town';

/**
 *
 * @export
 * @interface DeliveryRequest
 */
export interface DeliveryRequest {
  deliveryMode?: string;
  type?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryRequest
   */
  recipientName?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryRequest
   */
  contactNumber?: string;
  /**
   *
   * @type {Date}
   * @memberof DeliveryRequest
   */
  date?: Date;
  /**
   *
   * @type {string}
   * @memberof DeliveryRequest
   */
  preferredTime?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryRequest
   */
  deliveryLocation?: string;
  /**
   *
   * @type {GeoPoint}
   * @memberof DeliveryRequest
   */
  deliveryCoordinates?: GeoPoint;
  /**
   *
   * @type {string}
   * @memberof DeliveryRequest
   */
  zone?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryRequest
   */
  status?: string;
  /**
   * Delivery fee amount
   * @type {number}
   * @memberof DeliveryRequest
   */
  amount?: number;
  /**
   * Total value of packages being delivered
   * @type {number}
   * @memberof DeliveryRequest
   */
  packageTotal?: number;
  /**
   * Combined total of package value and delivery fee
   * @type {number}
   * @memberof DeliveryRequest
   */
  grandTotal?: number;
  /**
   *
   * @type {string}
   * @memberof DeliveryRequest
   */
  notes?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof DeliveryRequest
   */
  packages?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof DeliveryRequest
   */
  paymentMethod?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryRequest
   */
  referenceNumber?: string;
  /**
   *
   * @type {Date}
   * @memberof DeliveryRequest
   */
  createdAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof DeliveryRequest
   */
  updatedAt?: Date;
  /**
   *
   * @type {number}
   * @memberof DeliveryRequest
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof DeliveryRequest
   */
  courierId?: number;
  /**
   *
   * @type {number}
   * @memberof DeliveryRequest
   */
  customerId?: number;
  /**
   *
   * @type {number}
   * @memberof DeliveryRequest
   */
  deliveryLocationId?: number;

  /**
   *
   * @type {string}
   * @memberof DeliveryRequest
   */
  locationId?: string;

  /**
   *
   * @type {Town}
   * @memberof DeliveryRequest
   */
  town?: Town;

  location?: Location;
  pickupAddress?: string;
  pickupCoordinates?: GeoPoint;
  pickupContactName?: string;
  pickupContactPhone?: string;
  dropoffAddress?: string;
  dropoffCoordinates?: GeoPoint;
  dropoffContactName?: string;
  dropoffContactPhone?: string;
  itemDescription?: string;
  vehicleType?: string;
  estimatedDistance?: number;
}

/**
 * Check if a given object implements the DeliveryRequest interface.
 */
export function instanceOfDeliveryRequest(
  value: object
): value is DeliveryRequest {
  return true;
}

export function DeliveryRequestFromJSON(json: any): DeliveryRequest {
  return DeliveryRequestFromJSONTyped(json, false);
}

export function DeliveryRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DeliveryRequest {
  if (json == null) {
    return json;
  }
  return {
    deliveryMode: json['deliveryMode'] == null ? undefined : json['deliveryMode'],
    type: json['type'] == null ? undefined : json['type'],
    recipientName:
      json['recipientName'] == null ? undefined : json['recipientName'],
    contactNumber:
      json['contactNumber'] == null ? undefined : json['contactNumber'],
    date: json['date'] == null ? undefined : new Date(json['date']),
    preferredTime:
      json['preferredTime'] == null ? undefined : json['preferredTime'],
    deliveryLocation:
      json['deliveryLocation'] == null ? undefined : json['deliveryLocation'],
    deliveryCoordinates:
      json['deliveryCoordinates'] == null
        ? undefined
        : GeoPointFromJSON(json['deliveryCoordinates']),
    zone: json['zone'] == null ? undefined : json['zone'],
    status: json['status'] == null ? undefined : json['status'],
    amount: json['amount'] == null ? undefined : json['amount'],
    packageTotal: json['packageTotal'] == null ? undefined : json['packageTotal'],
    grandTotal: json['grandTotal'] == null ? undefined : json['grandTotal'],
    notes: json['notes'] == null ? undefined : json['notes'],
    packages: json['packages'] == null ? undefined : json['packages'],
    paymentMethod:
      json['paymentMethod'] == null ? undefined : json['paymentMethod'],
    referenceNumber:
      json['referenceNumber'] == null ? undefined : json['referenceNumber'],
    createdAt:
      json['createdAt'] == null ? undefined : new Date(json['createdOn']),
    updatedAt:
      json['updatedAt'] == null ? undefined : new Date(json['updatedAt']),
    id: json['id'] == null ? undefined : json['id'],
    courierId: json['courierId'] == null ? undefined : json['courierId'],
    customerId: json['customerId'] == null ? undefined : json['customerId'],
    deliveryLocationId:
      json['deliveryLocationId'] == null
        ? undefined
        : json['deliveryLocationId'],
    locationId: json['locationId'] == null ? undefined : json['locationId'],
    town: json['town'] == null ? undefined : TownFromJSON(json['town']),
    location:
      json['location'] == null ? undefined : LocationFromJSON(json['location']),
    pickupAddress: json['pickupAddress'] == null ? undefined : json['pickupAddress'],
    pickupCoordinates: json['pickupCoordinates'] == null ? undefined : GeoPointFromJSON(json['pickupCoordinates']),
    pickupContactName: json['pickupContactName'] == null ? undefined : json['pickupContactName'],
    pickupContactPhone: json['pickupContactPhone'] == null ? undefined : json['pickupContactPhone'],
    dropoffAddress: json['dropoffAddress'] == null ? undefined : json['dropoffAddress'],
    dropoffCoordinates: json['dropoffCoordinates'] == null ? undefined : GeoPointFromJSON(json['dropoffCoordinates']),
    dropoffContactName: json['dropoffContactName'] == null ? undefined : json['dropoffContactName'],
    dropoffContactPhone: json['dropoffContactPhone'] == null ? undefined : json['dropoffContactPhone'],
    itemDescription: json['itemDescription'] == null ? undefined : json['itemDescription'],
    vehicleType: json['vehicleType'] == null ? undefined : json['vehicleType'],
    estimatedDistance: json['estimatedDistance'] == null ? undefined : json['estimatedDistance'],
  };
}

export function DeliveryRequestToJSON(json: any): DeliveryRequest {
  return DeliveryRequestToJSONTyped(json, false);
}

export function DeliveryRequestToJSONTyped(
  value?: DeliveryRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    deliveryMode: value['deliveryMode'],
    type: value['type'],
    recipientName: value['recipientName'],
    contactNumber: value['contactNumber'],
    date: value['date'] == null ? undefined : value['date'].toISOString(),
    preferredTime: value['preferredTime'],
    deliveryLocation: value['deliveryLocation'],
    deliveryCoordinates: GeoPointToJSON(value['deliveryCoordinates']),
    zone: value['zone'],
    status: value['status'],
    amount: value['amount'],
    packageTotal: value['packageTotal'],
    grandTotal: value['grandTotal'],
    notes: value['notes'],
    packages: value['packages'],
    paymentMethod: value['paymentMethod'],
    referenceNumber: value['referenceNumber'],
    createdAt:
      value['createdAt'] == null ? undefined : value['createdAt'].toISOString(),
    updatedAt:
      value['updatedAt'] == null ? undefined : value['updatedAt'].toISOString(),
    id: value['id'],
    courierId: value['courierId'],
    customerId: value['customerId'],
    deliveryLocationId: value['deliveryLocationId'],
    locationId: value['locationId'],
    town: TownToJSON(value['town']),
    location: LocationToJSON(value['location']),
    pickupAddress: value['pickupAddress'],
    pickupCoordinates: GeoPointToJSON(value['pickupCoordinates']),
    pickupContactName: value['pickupContactName'],
    pickupContactPhone: value['pickupContactPhone'],
    dropoffAddress: value['dropoffAddress'],
    dropoffCoordinates: GeoPointToJSON(value['dropoffCoordinates']),
    dropoffContactName: value['dropoffContactName'],
    dropoffContactPhone: value['dropoffContactPhone'],
    itemDescription: value['itemDescription'],
    vehicleType: value['vehicleType'],
    estimatedDistance: value['estimatedDistance'],
  };
}
